// OPEN A DRIVE FILE IN ITS DESKTOP PROGRAM (Karan 09/10/2026, Files turn 8:
// "Open in AutoCAD … find a way please").
//
// A web page cannot start a program on somebody's computer. Two things on
// that computer can:
//   1  Google Drive for desktop, which already puts every shared drive on disk
//      (G:\Shared drives\… on Windows, ~/Library/CloudStorage/GoogleDrive-…/
//      Shared drives/… on a Mac);
//   2  Track Opener, a tiny helper installed once (Help → Files → Open in
//      AutoCAD), which answers asptrack:// links: it finds that file under
//      Drive for desktop and opens it with the computer's own program for it —
//      AutoCAD for a .dwg.
// Track sends the file's place on the drive, never a path on the computer, and
// the helper refuses anything outside Drive for desktop, any "..", and any file
// type not on its list (it will never run a program file). Source and
// installers: tools/track-opener/.
//
// Whether it worked: a browser gives a page no answer when a link goes to a
// program. If Track loses focus within a few seconds the program took it; if
// not, the caller shows how to install the helper.

import { driveFolderPlace } from './google-api.js';

export const OPENER_SCHEME = 'asptrack';
const OK_KEY = 'track-opener-seen';

/** asptrack://open?p=Shared%20drives/Projects/…/file.dwg&id=… */
export function openerUrl(segments, fileId = '') {
  const p = segments.map((s) => String(s).replace(/\//g, '_')).join('/');   // Drive for desktop shows "/" in a name as "_"
  const q = new URLSearchParams({ p });
  if (fileId) q.set('id', fileId);
  return `${OPENER_SCHEME}://open?${q.toString().replace(/\+/g, '%20')}`;
}

/** A phone or tablet has no desktop programs to open. */
export function canOpenOnDesktop() {
  const ua = navigator.userAgent || '';
  return !/iPhone|iPad|Android|Mobile/i.test(ua) && !(navigator.maxTouchPoints > 1 && /Macintosh/.test(ua));
}

export function openerSeen() { try { return localStorage.getItem(OK_KEY) === '1'; } catch (_) { return false; } }

/**
 * file        the Drive file ({ id, name })
 * folderId    the project's own folder on Drive
 * below       folder names from the project folder down to the file
 * Resolves 'opened' (Track lost focus — the program took it), 'unknown' (no
 * sign either way), or rejects when Drive could not say where the folder is.
 */
export async function openOnDesktop(file, { folderId, below = [] }) {
  const place = await driveFolderPlace(folderId);
  if (!place) throw new Error('Drive could not say where this project folder is.');
  const url = openerUrl([...place, ...below, file.name], file.id);
  return new Promise((resolve) => {
    let done = false;
    const finish = (r) => {
      if (done) return;
      done = true;
      window.removeEventListener('blur', onBlur);
      document.removeEventListener('visibilitychange', onBlur);
      if (r === 'opened') { try { localStorage.setItem(OK_KEY, '1'); } catch (_) { /* private mode */ } }
      resolve(r);
    };
    const onBlur = () => finish('opened');
    window.addEventListener('blur', onBlur);
    document.addEventListener('visibilitychange', onBlur);
    const a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    // The browser's own "Open Track Opener?" question can take a while to answer.
    setTimeout(() => finish('unknown'), 4000);
  });
}
